import { UIGameTimedAnimation } from './UIGameTimedAnimation.ts';
export class UIGameShakeAnimation extends UIGameTimedAnimation {
    updateAnimation(deltaTime, elapsedMS) {
        const { shakeX, shakeY, frequency, initialX, initialY } = this.options;
        const frequencyAbs = Math.abs(Math.round(frequency));
        const speedMultiplier = 4;
        const progress = this.totalElapsedMS / 1000;
        const offsetX = Math.sin(frequencyAbs * progress * Math.PI * speedMultiplier) * shakeX;
        const offsetY = Math.cos(frequencyAbs * progress * Math.PI * speedMultiplier) * shakeY;
        this.viewToAnimate.position.set(initialX + offsetX, initialY + offsetY);
    }
    resetToDefaultState() {
        this.viewToAnimate.position.set(this.options.initialX, this.options.initialY);
    }
    static getDefaultOptions(viewToAnimate) {
        return {
            shakeX: 5,
            shakeY: 0,
            frequency: 4,
            initialX: viewToAnimate.x,
            initialY: viewToAnimate.y
        };
    }
    constructor(viewToAnimate, animationDuration = 500, options){
        super(animationDuration), this.forceEnableAnimation = true;
        this.viewToAnimate = viewToAnimate;
        this.options = options !== null && options !== void 0 ? options : UIGameShakeAnimation.getDefaultOptions(viewToAnimate);
    }
}
